import ToolBar from "../Elements/ToolBar";
import {getGeneratedRoute, RouteEnumFinal} from "../../Config/RouteEnum";
import React from "react";


const GeneralStatistics = () => {

    return(
        <>
            <ToolBar title="آمار و گزارش ها" url={getGeneratedRoute(RouteEnumFinal.STORE_PANEL_URL_GENERATE)} />
            <div className="container">
                <div className="row justify-content-center">
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-between mt-12'>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        بازدید فروشگاه
                                    </div>
                                    <div className='mobile-body-1-regular cl-subtitle mt-6'>
                                        تعداد کل بازدیدها از زمان ساختن اکانت
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='img-cnt-24'>
                                    <img src={"/assets/images/vectors/arrow_left_gray.svg"}/>
                                </div>
                            </div>
                        </div>
                        <div className='divider-1px bg-gray-custom-1 mt-12'/>
                    </div>
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-between mt-12'>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        بازدید فروشگاه
                                    </div>
                                    <div className='mobile-body-1-regular cl-subtitle mt-6'>
                                        تعداد کل بازدیدها از زمان ساختن اکانت
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='img-cnt-24'>
                                    <img src={"/assets/images/vectors/arrow_left_gray.svg"}/>
                                </div>
                            </div>
                        </div>
                        <div className='divider-1px bg-gray-custom-1 mt-12'/>
                    </div>
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-between mt-12'>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        بازدید فروشگاه
                                    </div>
                                    <div className='mobile-body-1-regular cl-subtitle mt-6'>
                                        تعداد کل بازدیدها از زمان ساختن اکانت
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='img-cnt-24'>
                                    <img src={"/assets/images/vectors/arrow_left_gray.svg"}/>
                                </div>
                            </div>
                        </div>
                        <div className='divider-1px bg-gray-custom-1 mt-12'/>
                    </div>
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-between mt-12'>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        بازدید فروشگاه
                                    </div>
                                    <div className='mobile-body-1-regular cl-subtitle mt-6'>
                                        تعداد کل بازدیدها از زمان ساختن اکانت
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='img-cnt-24'>
                                    <img src={"/assets/images/vectors/arrow_left_gray.svg"}/>
                                </div>
                            </div>
                        </div>
                        <div className='divider-1px bg-gray-custom-1 mt-12'/>
                    </div>
                    <div className='col-12'>
                        <div className='d-flex align-items-center justify-content-between mt-12'>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        بازدید فروشگاه
                                    </div>
                                    <div className='mobile-body-1-regular cl-subtitle mt-6'>
                                        تعداد کل بازدیدها از زمان ساختن اکانت
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='img-cnt-24'>
                                    <img src={"/assets/images/vectors/arrow_left_gray.svg"}/>
                                </div>
                            </div>
                        </div>
                        <div className='divider-1px bg-gray-custom-1 mt-12'/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GeneralStatistics